var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reactive, watchEffect } from "vue";
import { calculateOffset, } from "../common/pagination";
import { useNotificationStore } from "./index";
import queryStringService from "src/shared/query-string-service";
export const USER_ID_QUERY_PARAM_NAME = "user_id";
export const useNotificationResultSet = (userId, parameters) => {
    const notificationStore = useNotificationStore();
    const resultSet = reactive({
        results: [],
        isLoading: false,
    });
    const updateResults = () => __awaiter(void 0, void 0, void 0, function* () {
        resultSet.isLoading = true;
        yield notificationStore.fetchNotificationsForUser(userId.value, {
            limit: parameters.value.limit,
            offset: calculateOffset(parameters.value),
            was_snoozed: parameters.value.was_snoozed,
        });
        queryStringService.setParameter(USER_ID_QUERY_PARAM_NAME, userId.value);
        resultSet.results = notificationStore.getNotifications();
        resultSet.isLoading = false;
    });
    watchEffect(updateResults);
    return resultSet;
};
export const useNotification = (userId, eventId) => {
    const result = reactive({
        isLoading: false,
        notification: undefined,
    });
    const notificationStore = useNotificationStore();
    const getNotification = () => __awaiter(void 0, void 0, void 0, function* () {
        result.isLoading = true;
        yield notificationStore.fetchNotifications(userId);
        result.notification = notificationStore.getNotification(eventId);
        result.isLoading = false;
    });
    getNotification();
    return result;
};
export const useNotificationCount = (userId) => {
    const notificationStore = useNotificationStore();
    const count = reactive({
        isLoading: false,
        count: 0,
    });
    const fetchNotificationCount = () => __awaiter(void 0, void 0, void 0, function* () {
        count.isLoading = true;
        yield notificationStore.fetchNotifications(userId, {
            was_snoozed: false,
        });
        yield notificationStore.fetchNotificationCursor();
        const notificationCursor = notificationStore.getNotificationCursor();
        const notifications = notificationStore.getNotifications();
        count.count = 0;
        notifications.forEach((notification) => {
            if (notification.isUnread(notificationCursor) &&
                !notification.wasSnoozed()) {
                count.count += 1;
            }
        });
        count.isLoading = false;
    });
    setInterval(() => {
        fetchNotificationCount();
    }, 30000);
    fetchNotificationCount();
    return count;
};
